import { FormModal, FormModalProps, theme } from '@mi-front/ui';
import CommentIcon from '@mui/icons-material/Comment';
import InfoIcon from '@mui/icons-material/Info';
import RestartAltIcon from '@mui/icons-material/RestartAlt';
import { Alert, Box, Typography } from '@mui/material';
import { FormattedMessage } from 'react-intl';

type Props = {
  data: object;
  onSubmit: (data: object) => any;
} & Pick<FormModalProps<any>, 'show' | 'onHide'>;

export function TranscriptionStartDialog(props: Props) {
  const { onSubmit, data, ...rest } = props;

  return (
    <FormModal
      title={
        <>
          <CommentIcon sx={{ verticalAlign: 'middle', mr: 0.5 }} />{' '}
          <FormattedMessage
            id="fragments.transcriptionStart.modalTitle"
            defaultMessage="Transcribir fragmento"
          />
        </>
      }
      onSubmit={(data) => onSubmit(data)}
      initialValues={data}
      saveLabel={
        <FormattedMessage id="fragments.transcriptionStart.startBtn" defaultMessage="Iniciar" />
      }
      savedLabel={
        <FormattedMessage id="fragments.transcriptionStart.startedBtn" defaultMessage="Iniciada" />
      }
      allowSave
      confirmCloseIfDirty={false}
      {...rest}
    >
      {({
        values,
        errors,
        touched,
        handleChange,
        handleBlur,
        handleSubmit,
        isSubmitting,
        setFieldTouched,
        setFieldValue,
      }) => (
        <Box>
          {(errors as any).response && (
            <Typography sx={{ color: theme.red, mb: 2 }}>
              <RestartAltIcon sx={{ verticalAlign: 'middle', mr: 0.5 }} />{' '}
              {(errors as any).response.data.message}
            </Typography>
          )}
          <Alert severity="info" icon={<InfoIcon />} sx={{ mb: 4 }}>
            <FormattedMessage
              id="fragments.transcriptionStart.notice"
              defaultMessage="Nota: las transcripciones pueden tomar mucho tiempo y pueden generar costos adicionales"
            />
          </Alert>
        </Box>
      )}
    </FormModal>
  );
}
